import React from 'react';

interface LentTableRefreshCtxValue {
  refreshTablePage: () => Promise<void>;
}

export const LentTableRefreshCtx = React.createContext<
  LentTableRefreshCtxValue
>({
  refreshTablePage: async () => {},
});
